import { createBrowserHistory, createMemoryHistory } from 'history';
import { FC, PropsWithChildren } from 'react';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';

const history =
  typeof window == 'undefined'
    ? createMemoryHistory()
    : createBrowserHistory({ window });

const RouterWithHistory: FC<PropsWithChildren> = ({ children, ...props }) => {
  return (
    // eslint-disable-next-line
    // @ts-ignore
    <HistoryRouter history={history} {...props}>
      {children}
    </HistoryRouter>
  );
};

export default RouterWithHistory;
